export interface PromoBanner {
  message: string
  mobileMessage: string
  link: any
}

export interface SpecialTheme {
  id: string
  shopifyPromoIds?: string[]
  bgTintColour: string
  bgColour: string
  midBgColour: string
  keyColour: string
  highlightColour: string
  shineColour: string
  type: 'default' | 'special'
}

export interface DatoPromotion {
  shopifyPromotionId: string
  theme: SpecialTheme
  bannerMessage: string
  mobileBannerMessage: string
  bannerLink: any
  productTagText: string
  showPolarisedTag: boolean
}

export function parseMessage(message: string) {
  // Support **bold**, __italic__ and ~~underline~~
  const bold = /(\*{2})(.*?)(\*{2})/g
  const italic = /(_{2})(.*?)(_{2})/g
  const underline = /(~{2})(.*?)(~{2})/g

  let parsedMessage = message
  parsedMessage = parsedMessage.replace(bold, '<b>$2</b>')
  parsedMessage = parsedMessage.replace(italic, '<i>$2</i>')
  parsedMessage = parsedMessage.replace(underline, '<u>$2</u>')

  return parsedMessage
}